import { Button } from '@quark/button'
import { Text } from '@quark/typography'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { parseBoldText } from '@utils/parseBoldText'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import { getDevicePlatform } from '@utils/segmentProperties'
import Image from 'next/image'
import { EXPLORE_NEW_CARD, ANALYTICS } from './config'
import styles from './GIBikeLanding.module.scss'

const ExploreNewCard = () => (
  <div className={styles.exploreNewCard}
    onClick={() => {
      void (async () => {
        try {
          await trackEvent('tap_btn_newbike_get_quote', {
            page: typeof window !== 'undefined' ? window.location.href : '',
            from_page: typeof document !== 'undefined' ? document.referrer : '',
            platform: getDevicePlatform(),
            journey: 'buy new bike',
            header_name: ANALYTICS.HEADER_NAMES,
            product: ANALYTICS.PRODUCT.AUTO_BIKE,
            funnel: ANALYTICS.FUNNEL.ENTRY,
            cta_text: EXPLORE_NEW_CARD.CTA,
          })
        } catch (error) {
          console.error('Failed to track explore new bike events:', error)
        }
        window.location.href = getUrlWithQueryParams(EXPLORE_NEW_CARD.LINK)
      })()
    }}>
    <div className={styles.content}>
      <div className={styles.textContent}>
        <Text
          whiteSpace="pre-line"
          fontStyle={{ lg: 'um_text-2xl/bold', md: 'um_text-2xl/bold', sm: 'um_text-lg/bold' }}>
          {parseBoldText(EXPLORE_NEW_CARD.TITLE, styles.highlight)}
        </Text>
        <Text fontStyle="um_text-sm/normal" color="base/secondary">
          {EXPLORE_NEW_CARD.DESCRIPTION}
        </Text>
      </div>
      <Image {...EXPLORE_NEW_CARD.IMAGE} />
    </div>
    <Button
      type="outline"
      size="block">
      {EXPLORE_NEW_CARD.CTA}
    </Button>
  </div>
)

export default ExploreNewCard
